import React from 'react'
import ProductForm from 'views/shared/ProductForm'
import BSQuinoaProduct from 'models/BSQuinoaProduct'
import BSQuinoaPackage from './BSQuinoaPackage'

const productOptions = {
  packagingInfo: <BSQuinoaPackage />,
  productTitle: 'Brand Specific Quinoa',
  model: BSQuinoaProduct,
  validCategories: ['16'],
  validSubCategories: ['014'],
  brandSpecific: true,
}

const BSQuinoa = () => <ProductForm product={productOptions} />

export default BSQuinoa
